import { createContext, useContext, useRef, useState } from "react";
import { GridState } from "ag-grid-community";

// Holds SOV grid UI state across the AddressCard unmount that TabView causes
// on a tab switch: the AG Grid state snapshot plus the group/freeze toggles.
// Mounted in LoadedReport (keyed by reportId), so state persists across tab
// switches but is discarded on report change or a return to the dashboard.
type SovGridStateValue = {
  gridStateRef: React.MutableRefObject<GridState | undefined>;
  expandedGroups: Set<string>;
  setExpandedGroups: React.Dispatch<React.SetStateAction<Set<string>>>;
  freezeColumns: boolean;
  setFreezeColumns: React.Dispatch<React.SetStateAction<boolean>>;
};

const SovGridStateContext = createContext<SovGridStateValue | null>(null);

export const SovGridStateProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const gridStateRef = useRef<GridState | undefined>(undefined);
  const [expandedGroups, setExpandedGroups] = useState<Set<string>>(new Set());
  const [freezeColumns, setFreezeColumns] = useState(false);

  return (
    <SovGridStateContext.Provider
      value={{
        gridStateRef,
        expandedGroups,
        setExpandedGroups,
        freezeColumns,
        setFreezeColumns,
      }}
    >
      {children}
    </SovGridStateContext.Provider>
  );
};

export const useSovGridState = (): SovGridStateValue => {
  const value = useContext(SovGridStateContext);
  if (!value) {
    throw new Error(
      "useSovGridState must be used within a SovGridStateProvider"
    );
  }
  return value;
};
